import React from "react";
import './SectionHeader.css';

const SectionHeader = (props) => {
    const {imageSrc = null, title = null, bgcolor= '#ECF2FF', fontColor = "#0D2EA0", svgIcon=false} = props
    return (
        <>
            {
                (title)
                ? <div className='my-devices-section-header-wrapper' style={{backgroundColor: bgcolor}}>
                    {!svgIcon && imageSrc && <img src={imageSrc} alt="section-header-icon"/>}
                    {svgIcon && imageSrc}
                    <span style={{color: fontColor}}>{title}</span>
                </div>
                : null
            }
        </>
    )
}

export default SectionHeader;